	export enum BusinessCentralApiCallTypeEnum {
		None = 0,
		Companies = 1,
		Clinic = 2,
		Patient = 3,
		Product = 4,
		Invoice = 5,
		PurchaseOrder = 6,
		Credit = 7,
		Payor = 8,
		Payment = 9,
		Receipt = 10,
		ReturnOrder = 11,
		CancelPurchaseOrder = 12,
    AdjustmentOrder = 13,
    Repair = 14,
    Requisition = 15
	}
